import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { AnalyticsHtmlButton } from '../Button';
import ScrollableWrapper from '../ScrollableWrapper';

export const ResultContainer = styled(ScrollableWrapper)`
  flex-grow: 2;
  padding: 8px 12px;
`;

export const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 100%;
  height: 100%;
`;

export const ExplainResultTopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  gap: 8px;
  border-bottom: 1px solid ${theme.colors.border};
`;

export const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

export const ExplainResultHeaderText = styled.div`
  padding-top: 8px;
  font-size: 16px;
  font-weight: 400;
  line-height: 32px;
  color: ${theme.colors.secondary900};
`;

export const ExplainResultSubHeader = styled.div`
  color: ${theme.colors.secondary900};
  font-size: 12px;
  font-weight: 400;
  line-height: 120%;
`;

export const SummarySectionsHeader = styled.div`
  cursor: pointer;
  font-weight: 600;
  font-size: 12px;
  color: ${theme.colors.secondary900};
  line-height: normal;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const SummarySectionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SummarySectionsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 4px;
  border: 1px solid ${theme.colors.border};
  padding: 0 4px;
  align-items: center;
`;

export const SummarySectionLabel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  color: ${theme.colors.secondary600};
  line-height: 22px;
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px;
`;

export const ResultFooterText = styled.div`
  color: ${theme.colors.secondary400};
  font-size: 9px;
  font-weight: 400;
  line-height: 16px;
  display: flex;
`;

export const ButtonsRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: right;
  gap: 4px;
`;

export const StyledStartButton = styled(AnalyticsHtmlButton)`
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  max-width: 272px;
  width: 272px;
  display: flex;
  height: 32px;
  padding: 0 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 4px;
  background: ${theme.colors.purple500};
  color: ${theme.colors.white};
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
  }
`;

export const LoadingMessageWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 80%;
`;
